"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_SampledData = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_decimal_1 = require("../Scalar/RTTI_decimal");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_positiveInt_1 = require("../Scalar/RTTI_positiveInt");
exports.RTTI_SampledData = t.recursion('ISampledData', function () {
    return t.intersection([
        t.type({
            origin: RTTI_Quantity_1.RTTI_Quantity
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            period: RTTI_decimal_1.RTTI_decimal,
            _period: RTTI_Element_1.RTTI_Element,
            factor: RTTI_decimal_1.RTTI_decimal,
            _factor: RTTI_Element_1.RTTI_Element,
            lowerLimit: RTTI_decimal_1.RTTI_decimal,
            _lowerLimit: RTTI_Element_1.RTTI_Element,
            upperLimit: RTTI_decimal_1.RTTI_decimal,
            _upperLimit: RTTI_Element_1.RTTI_Element,
            dimensions: RTTI_positiveInt_1.RTTI_positiveInt,
            _dimensions: RTTI_Element_1.RTTI_Element,
            data: t.string,
            _data: RTTI_Element_1.RTTI_Element
        })
    ]);
});
//# sourceMappingURL=RTTI_SampledData.js.map